export const NUM_BOARDING_INSURANCES = 6;
export const NUM_BOARDING_TAX_OTHERS = 3;
export const NUM_BOARDING_PROPERTIES = 15;
